import LeftBottomPanel from "./LeftBottomPanel";
import LeftTopPanel from "./LeftTopPanel";

export default function LeftPanel() {
  return (
    <div className="flex h-full w-1/3 flex-col gap-4">
      <LeftTopPanel />
      <LeftBottomPanel />
    </div>
  );
}
